import React, { useContext, useEffect } from 'react'
import { AppContext } from '../constants'
import { useHandleFormChange } from '../utils'

const Form = React.forwardRef((props, ref) => {
  const { formId, handleFormSubmit } = useContext(AppContext)

  useEffect(() => {
    document.documentElement.addEventListener('change', (e) => useHandleFormChange(e, formId, ref))
  }, [])

  return (
    <form className='currency-chart-ma__form' id={formId} onSubmit={handleFormSubmit} ref={ref} />
  )
})

export default Form
